<style scoped>
.mt9 {
  margin-top: 9px;
}

.tit {
  color: gray;
  width: 120px;
  padding-right: 10px;
  float: left;
  text-align: right;
}
</style>

<template>
  <div style="position: relative">
    <Spin fix v-if="loading"></Spin>

    <Divider orientation="left">基础信息</Divider>
    <Row class='mt9' v-if="detail.zs!=2">
      <Col span='6' class='tit'>课程信息：</Col>
      <Col span='18'>
        <!--<Avatar :src="detail.userinfo.avatarUrl"/>-->
        {{ detail.remarks }}
      </Col>
    </Row>

    <Row class='mt9'>

      <Col span='6' class='tit'>微信用户：</Col>
      <Col span='18'>
        <!--<Avatar :src="detail.userinfo.avatarUrl"/>-->
        {{ detail.userinfo.userName }}
      </Col>
    </Row>


    <Row class='mt9' v-if="detail.zs!=2">
      <Col span='6' class='tit'>报名人数：</Col>
      <Col span='18'><b>{{ detail.count }}人</b></Col>
    </Row>

    <Row class='mt9' v-if="detail.price">
      <Col span='6' class='tit'>合计金额：</Col>
      <Col span='18'><b>{{ detail.price }}</b></Col>
    </Row>

    <Row class='mt9'>
      <Col span='6' class='tit'>支付状态：</Col>
      <Col span='18'>
        <!--<Avatar :src="detail.userinfo.avatarUrl"/>-->
        <span v-if="detail.zfstate==='已支付'"
              style="color: orange;font-weight: bold">{{ detail.zfstate }}（{{ detail.money }}元）</span>
        <span v-else>{{ detail.zfstate }}</span>
      </Col>
    </Row>

    <Row class='mt9'>
      <Col span='6' class='tit'>报名时间：</Col>
      <Col span='18'>{{ detail.addTime }}</Col>
    </Row>


    <Divider orientation="left">学员信息</Divider>

    <div v-if="detail.trainee&&detail.zs==0">
      <Card v-for="item in detail.trainee" style="margin-bottom:20px;">
        <Row class='mt9'>
          <Col span='6' class='tit'>公司名称：</Col>
          <Col span='18'>{{ item.cname }}</Col>
        </Row>
        <Row class='mt9'>
          <Col span='6' class='tit'>姓名：</Col>
          <Col span='18'>{{ item.name }}</Col>
        </Row>
        <Row class='mt9'>
          <Col span='6' class='tit'>手机：</Col>
          <Col span='18'>{{ item.phone }}</Col>
        </Row>
        <Row class='mt9'>
          <Col span='6' class='tit'>邮箱：</Col>
          <Col span='18'>{{ item.email }}</Col>
        </Row>
        <Row class='mt9'>
          <Col span='6' class='tit'>职位：</Col>
          <Col span='18'>{{ item.position }}</Col>
        </Row>
        <!--        <Row class='mt9'>-->
        <!--          <Col span='6' class='tit'>微信号：</Col>-->
        <!--          <Col span='18'>{{item.weixin}}</Col>-->
        <!--        </Row>-->
      </Card>
    </div>

    <div v-if="detail.trainee&&detail.zs==1">
      <Card v-for="item in detail.trainee" style="margin-bottom:20px;">
        <Row class='mt9'>
          <Col span='6' class='tit'>姓名：</Col>
          <Col span='18'>{{ item.name }}
            <span v-if="item.id==detail.mr" style="color: #2d8cf0">（默认联系人）</span>
            <span v-if="item.id==detail.tb" style="color: orangered">（培训联系人）</span>
          </Col>
        </Row>
        <Row class='mt9'>
          <Col span='6' class='tit'>手机：</Col>
          <Col span='18'>{{ item.phone }}</Col>
        </Row>
        <Row class='mt9'>
          <Col span='6' class='tit'>邮箱：</Col>
          <Col span='18'>{{ item.email }}</Col>
        </Row>
        <Row class='mt9'>
          <Col span='6' class='tit'>职位：</Col>
          <Col span='18'>{{ item.position }}</Col>
        </Row>
      </Card>
    </div>

    <div v-if="detail.trainee&&detail.zs==2">
      <Card v-for="item in detail.trainee" style="margin-bottom:20px;">
        <Row class='mt9'>
          <Col span='6' class='tit'>姓名：</Col>
          <Col span='18'>{{ item.name }}
          </Col>
        </Row>
        <Row class='mt9'>
          <Col span='6' class='tit'>手机：</Col>
          <Col span='18'>{{ item.phone }}</Col>
        </Row>
        <Row class='mt9'>
          <Col span='6' class='tit'>微信号：</Col>
          <Col span='18'>{{ item.weixin }}</Col>
        </Row>
        <Row class='mt9'>
          <Col span='6' class='tit'>职位：</Col>
          <Col span='18'>{{ item.position }}</Col>
        </Row>
      </Card>
    </div>

  </div>
</template>

<script>
export default {
  props: ['id', 'token'],
  data() {
    return {
      detail: {},
      loading: false,
    }
  },
  methods: {
    load() {
      this.loading = true;
      let that = this;
      this.$axios.get('/api/apply/getByIdToken?id=' + this.id + '&token=' + this.token).then(function (rs) {
        that.detail = rs.data;
        that.loading = false;
      });
    }
  },
  created() {
    this.load();
  },
  watch: {
    id: {
      handler(newValue, oldValue) {
        this.load();
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/apply/ApplyDetailInfo.vue